module.exports = __webpack_public_path__ + "img/wallet_pc_01.bc2ce9c0.png";